var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditorQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76758 6.58994e-05C3.59878 -0.00210904 3.43414 0.0496094 3.30029 0.146857C3.30029 0.146857 0 2.52659 0 7.09587V14.1861C0 14.9696 0.67125 15.6042 1.5 15.6042H6C6.82875 15.6042 7.5 14.9696 7.5 14.1861V8.51392C7.5 7.73045 6.82875 7.09587 6 7.09587H2.96924C2.9506 5.83339 3.08131 3.13313 4.3667 1.12177C4.4464 1.01648 4.49409 0.892573 4.5046 0.763483C4.51511 0.634393 4.48802 0.505047 4.42629 0.389473C4.36456 0.273899 4.27054 0.176509 4.15442 0.107863C4.0383 0.0392178 3.90452 0.00193762 3.76758 6.58994e-05ZM14.2676 6.58994e-05C14.0988 -0.00210906 13.9341 0.0496094 13.8003 0.146857C13.8003 0.146857 10.5 2.52659 10.5 7.09587V14.1861C10.5 14.9696 11.1713 15.6042 12 15.6042H16.5C17.3288 15.6042 18 14.9696 18 14.1861V8.51392C18 7.73045 17.3288 7.09587 16.5 7.09587H13.4692C13.4506 5.83339 13.5813 3.13313 14.8667 1.12177C14.9464 1.01648 14.9941 0.892573 15.0046 0.763483C15.0151 0.634393 14.988 0.505047 14.9263 0.389473C14.8646 0.273899 14.7705 0.176509 14.6544 0.107863C14.5383 0.0392178 14.4045 0.00193763 14.2676 6.58994e-05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditorQuote);
export default __webpack_public_path__ + "static/media/icon_editor_quote.1dbb246da26c76ba6405e633658d787a.svg";
export { ForwardRef as ReactComponent };